// ======================================================================
// File Name       : UserTypeAuthConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as FUNCTION from './FunctionConstants';
import { LO_SUPER_USER, SUPER_USER } from './index';

const SUPER_USER_FUNCTIONS = [
  FUNCTION.SERVICE_LOGIN,
  FUNCTION.NOTIFICATION_LIST,
  FUNCTION.NOTIFICATION_DETAIL,
  FUNCTION.NOTIFICATION_EDIT,
  FUNCTION.NOTIFICATION_REGISTER,
  FUNCTION.NOTIFICATION_IMPORT,
];

const UNIFY_SUPER_USER_FUNCTIONS = [
  ...SUPER_USER_FUNCTIONS,
  FUNCTION.SERVICE_RECORD_DOWNLOAD_FORM,
];

const USER_TYPE_FUNCTION_AUTHORITY = {
  [SUPER_USER]: SUPER_USER_FUNCTIONS,
  [LO_SUPER_USER]: UNIFY_SUPER_USER_FUNCTIONS,
};

export default USER_TYPE_FUNCTION_AUTHORITY;
